import "./style.scss"
import { useDispatch } from "react-redux"
import { incrementByAmount } from "../../store/Header";
import { useEffect, useRef } from "react";
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import EadlineCom from "../../components/EadlineCom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPageListAPI, getBlogsListAPI } from "../../api/index";
import BlogCom from "../../components/BlogCom";
import ChatCom from "../../components/ChatCom";
import { serviceList } from "../HongKongPage/config.js";
import { TeacherDatalist, talkList } from "./config.js";
// import BlogCom from "../../components/BlogCom";
const HongKongEngPage = () => {
    const dispatch = useDispatch()
    const carouselRef = useRef(null);
    const [serviceContentList, setServiceContentList] = useState(serviceList);
    const [blogList, setBlogList] = useState(null)
    let colList = ["#C4EFDC", "#F9F3FF", "#E8EBCD"]
    const nav = useNavigate();
    const goMath = (url) => {
        nav(url);
    };
    useEffect(() => {
        dispatch(incrementByAmount(4));
        getBlogsListAPI({ type: '4', page: 1, limit: 10 }).then((res) => {
            setBlogList(res);
        })
        document.title = '英文補習｜小學英文補習｜英文補習一對一｜';
        let description = '无论是为了孩子的升学之路，还是未来的职业发展，英文补习在港澳地区都将持续成为家长们关注的焦点。而像 Sino-bus 这样专业、有特色的补习机构，也将继续为学生们提供优质的英语教育资源。';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', description);
        } else {
            // 如果不存在则创建新的标签
            const newMeta = document.createElement('meta');
            newMeta.name = 'description';
            newMeta.content = description;
            document.head.appendChild(newMeta);
        }
        let content = 'Sinobus 是香港專業的4-16歲学生補習專家，提供全面的數學、中文及英語課程。我們致力於為學生打造個性化的學習體驗，提升成績的同時，培養自主學習能力。立即加入 Sinobus，一對一教學助力4-16歲孩子在補習中脫穎而出！'
        // 清理函数（可选）
        return () => {
            if (metaDescription) {
                metaDescription.setAttribute('content', content);
                // metaDescription.removeAttribute('content');
            }
        };
    }, []);
    const chatUsCom = () => {
        let url = "https://api.whatsapp.com/send/?phone=8617788052878&text=%E8%AB%AE%E8%A9%A2%E8%8B%B1%E6%96%87%E8%AA%B2%E7%A8%8B";
        return (
            <div className="chatUs" onClick={() => { window.open(url) }}>
                <div className=""><img src="../assets/HK/service.png" alt="" /> 點擊咨詢</div>
            </div>
        );
    }
    const teacherItemCom = (item, index) => {
        return (
            <div key={index} className={['teacherItem', index === 1 ? "higthBox" : ""].join(" ")}>

                <div className="teacherHead" style={{ backgroundColor: colList[index] }}><img src={item.picture} alt="" /></div>
                <div className="teacherContent">
                    <div className="teacherName">
                        {item.name}<span>{item.quality}</span>
                    </div>
                    <div className="teacherInfo">{item.introduce}</div>
                </div>
            </div>
        )
    }
    const serviceContentCom1 = (item, index) => {
        return (
            <div key={index} className={['serviceItem', index % 2 != 0 ? "service1" : ""].join(" ")}>
                <div className="left">
                    <div className="serviceTitle">{item.title}</div>
                    <div className="serviceInfo">{item.content}</div>
                </div>
                <div className="right"> <img src={item.picture} alt="" /></div>
            </div>
        )
    }
    return (
        <div className="hkPage">
            <div className="topBut">
                <button className="but2" onClick={() => { goMath('/hongkong/') }} >香港中文</button>
                <button className="but2" onClick={() => { goMath('/hongkongmaths/') }}>香港数学</button>
                <button className="but1" onClick={() => { goMath('/hongkong-English/') }} >香港英文</button>
            </div>
            <div className="barrn">
                <img className="imgMob" src='../assets/hkEngimg/engbanner.jpg' alt="" />
                <img className="imgPc" src='../assets/hkEngimg/engbanner-pc.jpg' alt="" />
                <div className="nameTitle1">
                    <div>樂 學 英 文</div>
                    <div className="englishTitle">Enjoy Learning English</div>
                </div>

            </div>
            <EadlineCom name="課程簡介" />
            <div className="text">
                香港，英文補習係一個非常普及嘅現象，好多學生同成年人都會透過補習嚟提升佢哋嘅英文能力，英文補習可以幫助學生更好咁理解課程內容、提高考試成績，亦可以幫助成年人提升專業技能或者提升生活中嘅英文能力。
                <br />
                我哋嘅教學理念：「費曼教學法」，以學生為主體，寓教於樂，因材施教。
                我哋嘅特色：以學生為中心，定制化學習，通過任務闖關模式，情景化教學，角色扮演等遊戲化學習，令小朋友沉浸其中。
                主要培養能力：全面鍛煉小朋友嘅聼、講、讀、寫能力，提高英語綜合素養，培養英語思維。
                <br />
                如果你亦想打破英文學習嘅瓶頸，充分發揮自己嘅潛力，不妨考慮參加 sino-bus 英文補習。喺香港呢個競爭激烈嘅環境入面，掌握好英文就係掌握咗未來，選擇好似 sino-bus 噉靠譜嘅補習機構，開啟你嘅英文提升之旅，相信唔久嘅將來，你亦都可以自信噉用英文表達自我，擁抱更多機遇。
            </div>
            <div className="courseMol">
                <img src="../assets/hkEngimg/classeng.jpg" alt="" />
            </div>
            {chatUsCom()}
            <EadlineCom name="教師資質" />
            <div className="teachers">
                {TeacherDatalist.map((item, index) => {
                    return teacherItemCom(item, index)
                })}
            </div>
            <div className="teachers teacherMob">
                <Carousel effect="fade" autoplay autoplaySpeed={4000}>
                    {TeacherDatalist.map((item, index) => {
                        return teacherItemCom(item, index)
                    })}
                </Carousel>
            </div>
            {chatUsCom()}
            <div className="teacherAptitude">
                <EadlineCom name="教師資質" />
                <div className="aptitudeImg">
                    <img className="aptitudePc" src="../assets/hkEngimg/tPC.png" alt="" />
                    <img className="aptitudeMob" src="../assets/hkEngimg/tM.png" alt="" />
                </div>
                {chatUsCom()}
            </div>
            <EadlineCom name="家長與老師互動" />
            <div className="service">
                <div className="arrow" onClick={() => { carouselRef.current.prev() }}><LeftOutlined /> </div>
                <div className="interact">
                    <div>
                        <Carousel effect="fade" autoplay dots={true} ref={carouselRef} autoplaySpeed={4000}>
                            {talkList.map((item, index) => (
                                <div className="swiperImg" key={index} >
                                    <img className="talkImg" src={item} alt="" />
                                </div>))}

                        </Carousel>
                    </div>
                </div>
                <div className="arrow" onClick={() => { carouselRef.current.next() }}>
                    <RightOutlined />
                </div>
            </div>
            {chatUsCom()}
            <EadlineCom name="博客" />
            {
                blogList != null ? <BlogCom data='4' blogLists={blogList} /> : null
            }
            <EadlineCom name="服務内容" />
            <div className="serviceContent">
                {serviceContentList.map((item, index) => {
                    return serviceContentCom1(item, index)
                })}
            </div>
            {chatUsCom()}
            <div style={{ marginBottom: "30px" }}></div>
            <ChatCom url='https://wa.me/8615309292067?text=%E6%83%B3%E5%92%A8%E8%A9%A2%E8%8B%B1%E6%96%87' />
        </div >
    )
}
export default HongKongEngPage;